import React from "react";
import {
  DashboardOutlined,
  ClusterOutlined,
  KeyOutlined,
  UserOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import { Route } from "@ant-design/pro-layout/lib/typings";
import routes from "constants/routes";
import { useIsAdministrator } from "./hooks/usePermission";
const useRouteConfig = (): Route => {
  const isAdministrator = useIsAdministrator();

  return React.useMemo(() => {
    return {
      path: routes.OVERVIEW,
      routes: [
        {
          name: "工作台",
          icon: <DashboardOutlined />,
          path: routes.OVERVIEW,
          routes: [
            {
              path: routes.OVERVIEW,
              name: "站点概览",
            },
            {
              path: routes.MONITOR,
              name: "数据大屏",
            },
          ],
        },
        {
          name: "设备管理",
          icon: <ClusterOutlined />,
          path: routes.DEVICE_LIST,
          routes: [
            {
              path: routes.DEVICE_LIST,
              name: "设备列表",
            },
            {
              path: routes.DEVICE_ADD,
              name: "新增设备",
              hideInMenu: !isAdministrator,
            },
          ],
        },
        {
          name: "凭证管理",
          hideInMenu: !isAdministrator,
          icon: <KeyOutlined />,
          path: routes.CREDIT_LIST,
        },
        {
          name: "用户管理",
          hideInMenu: !isAdministrator,
          icon: <UserOutlined />,
          path: routes.USER_LIST,
          routes: [
            {
              path: routes.USER_LIST,
              name: "用户列表",
            },
            {
              path: routes.USER_INVITATION_LIST,
              name: "邀请记录",
            },
          ],
        },
        {
          name: "数据报表",
          icon: <DatabaseOutlined />,
          path: routes.DATA_LIST,
          routes: [
            {
              path: routes.DATA_LIST,
              name: "历史数据",
            },
          ],
        },
      ],
    };
  }, [isAdministrator]);
};

export default useRouteConfig;
